var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.7368,
    height: 2.24088,
    rx: 1.12044,
    transform: "matrix(0.747828 0.663892 -0.72358 0.690241 1.625 0.000488281)",
    fill: "#52447D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.7369,
    height: 2.24088,
    rx: 1.12044,
    transform: "matrix(-0.748228 0.663441 0.723202 0.690637 17.3828 0.00537109)",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup102);
export default __webpack_public_path__ + "static/media/Group 102.8c8a45c9d5084e898c2ad3a473a21efb.svg";
export { ForwardRef as ReactComponent };